<template>
  <section class="calm__form-section">
    <div class="calm__form-section__head">
      <span v-if="num !== null && num !== ''" class="calm__form-section__num">
        {{ num }}
      </span>
      <div class="calm__form-section__heading">
        <slot name="title">
          <div v-if="title" class="calm__form-section__title">{{ title }}</div>
        </slot>
        <div v-if="hint" class="calm__form-section__hint">{{ hint }}</div>
      </div>
      <div v-if="$slots.actions" class="calm__form-section__actions">
        <slot name="actions"></slot>
      </div>
    </div>

    <div class="calm__form-section__body">
      <!-- caller drops a .calm__form-grid (--1/--2/--3) of CalmFormRow here,
           or any custom markup -->
      <slot></slot>
    </div>
  </section>
</template>

<script>
export default {
  name: "calm-form-section",
  props: {
    num: { type: [Number, String], default: null }, // numbered badge; omit to hide
    title: { type: String, default: "" },
    hint: { type: String, default: "" },
  },
};
</script>
